<template>
  <list-table
    :url="url"
    title="درخواست های شارژ"
    :fields="fields"
    :params="params"
    :detailUrl="detailUrl"
  ></list-table>
</template>
<script>
import TableShowData from "../../components/table";
import persianDate from '../../helpers/persianDate';
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
export default {
  name: "RefundList",
  data() {
    return {
      url: "refund",
      fields: [
        {
          key: "detail.name",
          label: "پرداخت کننده",
        },
        {
          key: "created_at",
          label: "تاریخ ثبت",
          formatter(value , key,item){
              return persianDate.getDateByFormat(value);
          }
        },
        {
          key: "bed",
          label: "مبلغ (ریال)",
          formatter(value , key,item){
              return Number(value).toLocaleString()
          }
        },
        {
          key: "status",
          label: "وضعیت پرداخت",
          formatter(value , key,item){
            return item.parent_id!=null ? "پرداخت شده" : "پرداخت نشده";
          },
          tdClass(value,key,item){
            return item.parent_id!=null ? "text-success" : "text-danger";
          }
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
      params: [
        {
          label: "از تاریخ :",
          field: "dateFrom",
          type: "date-picker"
        },
        {
          label: "تا تاریخ:",
          field: "dateTo",
          type: "date-picker"
        },
        {
          label: "مبلغ (ریال) :",
          field: "amount",
          type: "number"
        },
        {
          label: "وضعیت :",
          field: "status",
          type: "select",
          value:null,
          options:[
            {text:"همه",value:null},
            {text:"پرداخت شده",value:"success"},
            {text:"پرداخت نشده",value:"failed"},
          ]
        },
      ],
      detailUrl: 'undoneRefund',
    };
  },
  components: {
    "list-table": TableShowData,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "درخواست های شارژ"}]);
  },
};
</script>